import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ContractCurrency, LocationType, OrderIncoTerm,
    PaymentTerms,
} from 'app/enums/label.enums'

import {
    BillingCompany,
} from '../BillingCompanyForm.types'

const getCustomerSalesAreaFields = (
    getAllowedValues: (enumType: any) => Record<string, string>,
): DTOCardFormField<keyof BillingCompany>[] => {
    return [{
        id: 'customerSalesArea',
        title: 'Customer Sales Area',
        className: 'customerSalesArea',
        'data-testid': 'card-customerSalesArea',
        fields: [
            {
                id: 'communication-column1',
                fields: [
                    {
                        name: 'paymentTerms',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(PaymentTerms),
                        required: true,
                        useDropdown: true,
                        labelKey: 'BillingCompanyDto.paymentTerms',
                    },
                    {
                        name: 'defaultCurrency',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ContractCurrency),
                        useDropdown: true,
                        required: true,
                        labelKey: 'BillingCompanyView.defaultCurrency',
                    },
                ],
            },
            {
                id: 'communication-column2',
                fields: [
                    {
                        name: 'defaultIncoTerm',
                        componentName: 'Select',
                        allowedValues: getAllowedValues(OrderIncoTerm),
                        required: true,
                        noNone: true,
                        labelKey: 'BillingCompanyView.defaultIncoTerm',
                    },
                    {
                        name: 'incoTermLocation',
                        componentName: 'LocationObjectSelector',
                        filterLocationType: LocationType.AIRPORT,
                        required: true,
                        labelKey: 'BillingCompanyView.incoTermLocation',
                    },
                ],
            },
        ],
    }]
}

export default getCustomerSalesAreaFields
